module.exports = __webpack_public_path__ + "img/logout.96a9f0c7.svg";